import { useMemo } from 'react';
import type { FeatureCollection } from 'geojson';
import { useSelector } from 'react-redux';
import { isEqual } from '../../../helpers/isEqual';
import { ResultsType } from '../types';

const usePolygons = (): FeatureCollection => {
  const areas = useSelector((state: any) => state.map.areas);
  const compounds = useSelector((state: any) => state.map.compounds);
  const selectedArea = useSelector((state: any) => state.map.selectedArea);
  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );
  const resultsType = useSelector(
    (state: any) => state.map.resultsType,
    isEqual
  );
  const polygons = resultsType === 'areas' ? areas : compounds;
  const generateGeoJson = (): FeatureCollection => {
    return {
      type: 'FeatureCollection',
      features: polygons?.map((polygon: any) => ({
        type: 'Feature',
        geometry: {
          type: polygon.geometry?.type,
          coordinates: polygon.geometry?.coordinates
        },
        properties: {
          id: polygon.id,
          isSelected:
            resultsType == ResultsType.COMPOUNDS
              ? selectedCompound?.parent_id
                ? polygon.id === selectedCompound?.parent_id
                : polygon.id === selectedCompound?.id
              : false,
          isFiltered: polygon.isFiltered
        }
      }))
    };
  };

  const polygonLocations = useMemo(
    () => generateGeoJson(),
    [areas, compounds, selectedCompound]
  );

  return polygonLocations;
};

export default usePolygons;
